import { Button } from 'antd';
import { useIntl } from 'react-intl';

import { CheckOutlined } from '@ant-design/icons';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import InfiniteTable, { ColumnsType } from '@/components/_common/InfiniteTable';

import { useInsurers } from '@/core/domain/people/Insurers/Insurers.hooks';
import { Insurer } from '@/core/domain/people/Insurers/Insurers.types';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';

interface Props {
  handleSelect: (name: string, id: number) => void;
}

function InsurersList({ handleSelect }: Props) {
  const intl = useIntl().formatMessage;
  const { data, isFetching, hasNextPage, fetchNextPage } = useInsurers();
  const listagem = flatInfiniteData(data);
  const columns: ColumnsType<Insurer> = [
    {
      title: 'CNPJ',
      dataIndex: 'cnpj',
      key: 'cnpj',
      width: COLUMNS_WIDTH.document,
      ellipsis: true,
    },
    {
      title: intl({
        id: 'layout.menu.fiscal.invoice.referenced.list.name',
      }),
      dataIndex: 'name',
      key: 'name',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      title: intl({
        id: 'layout.menu.fiscal.invoice.referenced.list.fantasyName',
      }),
      dataIndex: 'fantasyName',
      key: 'fantasyName',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: 'actions',
      align: 'center',
      width: COLUMNS_WIDTH.small,
      fixed: 'right',
      render: (_, row) => (
        <Button
          type="primary"
          onClick={() => handleSelect(row.name, row.id)}
          icon={<CheckOutlined />}
        />
      ),
    },
  ];
  return (
    <InfiniteTable
      fetchNextPage={fetchNextPage}
      columns={columns}
      hasNextPage={hasNextPage}
      loading={isFetching}
      dataSource={listagem}
      rowKey={(row) => row.id}
      scroll={{ x: getTableScrollX(columns) }}
    />
  );
}

export default InsurersList;
